import { Outlet } from "react-router-dom";

const OnboardingPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <div className="w-full max-w-screen-md p-16 bg-white rounded-lg shadow-lg dark:bg-zinc-900">
        <Outlet />
      </div>
    </div>
  );
};

export default OnboardingPage;
